// extracted by mini-css-extract-plugin
module.exports = {"title":"booking-hero_title__2K_r7","container":"booking-hero_container__-37Vz"};